import { cn } from '@/lib/utils';

/** Nome público do Ace — sempre minúsculas (convenção xat). */
export function formatAceDisplayName(name: string): string {
  const t = name.trim();
  if (!t) return '';
  return t.toLowerCase();
}

/** Caixa orbital do smilie nos Aces (âmbar/dourado). */
export const ACE_ICON_SHELL_STYLE = {
  background:
    'radial-gradient(circle at 50% 48%, #3d2a06 0%, #2a1d04 42%, #1a1203 75%, #0d0902 100%)',
  boxShadow:
    '0 0 0 1.5px #5c4010, 0 0 0 2.5px #7a5218, 6px 10px 22px rgba(0,0,0,0.55)',
} as const;

export const ACE_ID_BADGE_STYLE = {
  background: 'linear-gradient(135deg, #3d2a06 0%, #2a1d04 100%)',
  color: '#fcd34d',
  boxShadow: '0 0 0 1.5px #7a5218',
} as const;

/** CTA «Assine agora» — compacto, na mesma linha das badges do hero. */
export const aceSubscribeButtonClass = cn(
  'group relative inline-flex shrink-0 items-center justify-center gap-1.5 overflow-hidden rounded-full',
  'px-4 py-1.5 font-poppins text-xs font-bold uppercase tracking-wider text-[#1a1203]',
  'transition-[filter,box-shadow,transform] duration-200',
  'hover:brightness-110 active:scale-[0.98]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-[#030023]'
);

export const ACE_SUBSCRIBE_BUTTON_STYLE = {
  background: 'linear-gradient(90deg, #fbbf24 0%, #f59e0b 45%, #d97706 100%)',
  boxShadow:
    '0 0 0 1px rgba(251,191,36,0.5), 0 4px 14px rgba(245,158,11,0.3), inset 0 1px 0 rgba(255,255,255,0.28)',
} as const;

/** Separador vertical entre badges e CTA na mesma linha. */
export const aceCtaSeparatorClass = cn(
  'mx-2 h-7 w-px shrink-0 bg-gradient-to-b from-transparent via-white/25 to-transparent'
);
